/**
 * @module interface
 */
export interface V2TimFileElem {
    path?: string;
    fileName?: string;
    UUID?: string;
    url?: string;
    fileSize?: number;
    localUrl?: string;
}
